// Mantém os parâmetros das listas ao validar rotas que também têm abas/editores.
export function withListSearch<T extends Record<string, unknown>>(
  validate: (search: Record<string, unknown>) => T,
  ownedKeys: readonly string[],
) {
  return (search: Record<string, unknown>): T => {
    const rest = { ...search };
    for (const key of ownedKeys) delete rest[key];
    return { ...rest, ...validate(search) };
  };
}
